module.exports = __webpack_public_path__ + "static/media/symbol-gm_white.40006ef1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/symbol-gm_white.svg
// module id = ./src/assets/images/symbol-gm_white.svg
// module chunks = 0